<mat-progress-spinner class="mat-progress-spinner-accueil" *ngIf="!initLogin" mode="indeterminate"></mat-progress-spinner>

<div class="login-container" *ngIf="initLogin && !isLoggedIn">
  <mat-card class="login-card">
    <mat-card-header>
      <mat-card-title>DragUploader</mat-card-title>
      <mat-card-subtitle>Connexion avec les identifiants LeSonUnique</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      <form [formGroup]="formLogin" novalidate (ngSubmit)="login(formLogin.value, formLogin.valid)" class="login-form">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Email</mat-label>
          <input type="email" formControlName="identifiant" matInput autocomplete="email">
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Mot de passe</mat-label>
          <input [type]="hidePassword ? 'password' : 'text'" formControlName="password" matInput autocomplete="current-password">
          <button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword"
                  [attr.aria-label]="hidePassword ? 'Afficher le mot de passe' : 'Masquer le mot de passe'">
            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </mat-form-field>

        <button mat-raised-button color="primary" class="full-width submit-btn" type="submit">
          Se connecter
        </button>
      </form>
    </mat-card-content>
  </mat-card>
</div>
